// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientWelcomeSummaryResponse {
    static getAttributeTypeMap() {
        return MangoHubGetPatientWelcomeSummaryResponse.attributeTypeMap;
    }
}
MangoHubGetPatientWelcomeSummaryResponse.discriminator = undefined;
MangoHubGetPatientWelcomeSummaryResponse.attributeTypeMap = [
    {
        "name": "patientFirstName",
        "baseName": "patientFirstName",
        "type": "string"
    },
    {
        "name": "isVerified",
        "baseName": "isVerified",
        "type": "boolean"
    }
];
//# sourceMappingURL=mangoHubGetPatientWelcomeSummaryResponse.js.map